import { render, staticRenderFns } from "./AdvisorPage.vue?vue&type=template&id=c726b914&scoped=true"
import script from "./AdvisorPage.vue?vue&type=script&lang=js"
export * from "./AdvisorPage.vue?vue&type=script&lang=js"
import style0 from "./AdvisorPage.vue?vue&type=style&index=0&id=c726b914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c726b914",
  null
  
)

export default component.exports